import { useEffect, useState } from 'react'

/**
 * O valor depois de a pessoa parar de digitar.
 *
 * Cada letra na caixa de busca recarrega a lista e os contadores; digitar
 * "gengiva" mandava sete buscas e jogava seis fora. Além de trabalho à toa,
 * era o que fazia o servidor cortar com "muitos pedidos" no meio da procura.
 *
 * A caixa continua respondendo a cada tecla: o que espera é a consulta.
 */
export function useValorComPausa<T>(valor: T, milissegundos = 300): T {
  const [atrasado, setAtrasado] = useState(valor)

  useEffect(() => {
    const relogio = setTimeout(() => setAtrasado(valor), milissegundos)
    return () => clearTimeout(relogio)
  }, [valor, milissegundos])

  return atrasado
}
